import { useAppDispatch } from 'app/providers/Store';
import { IStore } from 'app/providers/Store/model/store';
import { hideModal, showModal } from 'entities/modal';
import { useSelector } from 'react-redux';
import { ModalId } from 'shared/constants/modals';

export const useModal = () => {
  const dispatch = useAppDispatch();
  const modal = useSelector((state: IStore) => state.modalReducer);

  const open = (id: ModalId) => {
    dispatch(showModal({ id }));
  };

  const close = (id: ModalId) => {
    dispatch(hideModal(id));
  };

  return {
    modal,
    open,
    close,
  };
};
